"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.addToBasket = void 0;
var AddToBasketEvent = _interopRequireWildcard(require("@ori-events/add-to-basket"));
var _analyticsData = require("@ori/analytics-data");
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
const addToBasket = (param)=>{
    let { pageIndex, productId, title, quantity } = param;
    const event = new CustomEvent(AddToBasketEvent.Name, {
        detail: {
            globalName: '',
            itemCode: Number.parseInt(productId, 10).toString(),
            localName: title,
            placement: _analyticsData.Placement.DigitalCatalogueECatalogue,
            position: pageIndex + 1,
            quantity
        }
    });
    window.dispatchEvent(event);
};
exports.addToBasket = addToBasket;
